import styled from 'styled-components'
import { layout } from 'styles/layout'
import { palette } from 'src/styles/colors'

export const Wrapper = styled.div`
  position: relative;
  max-width: 100vw !important;
  background-color: ${palette.catskillWhite};
`

export const OurStoryTextContainer = styled.div`
  display: grid;
  justify-content: center;
  max-width: 1020px;
  margin: -35% auto 0;

  > h1 {
    margin-bottom: 5.3rem;
  }

  > p {
    margin-bottom: 2.8rem;

    > a {
      text-decoration: underline;
      color: ${palette.greyText}
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    margin-top: -15%;

    > h1 {
      margin-bottom: 2rem;
    }

    > p {
      margin-bottom: 1.8rem;
    }
  }
`

export const OurStoryContent = styled.div`
  position: relative;
  max-width: 100vw;
  margin: 0 auto;
  display: grid;
  justify-content: center;
  padding: 100px 130px;

  @media all and (max-width: ${layout.subLg}) {
    padding: 70px 100px 90px;
  }

  @media screen and (max-width: ${layout.sm}) {
    padding: 70px 35px;
  }
`

export const TreesImageContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: -20px;
  max-width: 340px;

  @media screen and (max-width: ${layout.sm}) {
    max-width: 160px;
    right: -5px;
  }
`

export const TreesWithSquareImageContainer = styled.div`
  position: absolute;
  top: -270px;
  left: -100px;
  max-width: 380px;

  @media screen and (max-width: ${layout.sm}) {
    max-width: 190px;
    top: -46px;
    left: -60px;
  }
`

export const DotGuyImageContainer = styled.div`
  position: absolute;
  top: -450px;
  right: -100px;
  max-width: 290px;

  @media screen and (max-width: ${layout.sm}) {
    max-width: 140px;
    top: -120px;
    right: -60px;
  }
`
